import {WidgetEventStruct} from '../../widget-event.struct';
import {ModalWidgetEnum} from '../../../enums';

export class ModalWidgetEventStruct extends WidgetEventStruct {
  public event_modal_widget_type: ModalWidgetEnum;
} // end Package
